import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';
import { SIGNUP_TYPES } from '../_types/schema.types';

export const getTitleBySignupType = () => {
  const schemaData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  const signupType = schemaData?.signupType || SIGNUP_TYPES.OPEN;
  const isOpenFlow = signupType === SIGNUP_TYPES.OPEN;
  
  return isOpenFlow ? 'Preencha as informações' : 'Complete seu cadastro';
};
